import { WidgetType } from './widgetType';
export const ListWidgetHelper = {
    isListWidget: (widget) => {
        return widget.value.type === WidgetType.list;
    },
    isListServerData(widget) {
        return widget.type === WidgetType.list;
    },
    canListBeRequired: (data, properties) => {
        return properties.type === 'checkbox';
    },
    makeDefaultProperties: () => ({
        displayDelayInSeconds: 0,
        color: '#9B9B9B',
        type: 'numbered',
        indent: 's',
        isRequired: false,
    }),
    createBasicList: () => ({
        type: WidgetType.list,
        data: {
            texts: [''],
        },
        properties: ListWidgetHelper.makeDefaultProperties(),
    }),
};
